module.exports = __webpack_public_path__ + "static/media/expressiveBeachVibes-small.b67c167e.jpg";